import styles from "./UtilBox.module.scss"

import React, { useCallback } from "react"
import {FaCog, FaSearch, FaTimes} from "react-icons/fa"
import { RiChatSettingsFill } from "react-icons/ri"
import { useParams } from "react-router-dom"

import { useLayerPopupContext, Viewer } from "@shared/contexts"

import classNames from "classnames"

interface Props {
  users: Viewer[]
  searchKeyword: string
  onSearchKeywordChange: (keyword: string) => void
  isSearch: boolean
  onIsSearchChange: (active: boolean) => void
  showUserSearchButton?: boolean
}

function UtilBox({
  users,
  searchKeyword,
  onSearchKeywordChange,
  isSearch,
  onIsSearchChange,
  showUserSearchButton
}: Props) {
  const { open } = useLayerPopupContext()
  const { scheduleId, streamerName } = useParams<{
    scheduleId?: string
    streamerName?: string
  }>()

  const openHotkeyPage = useCallback((): void => {
    window.open(
      `/${streamerName}/${scheduleId}/streamer-hotkeys`,
      "streamer-hotkeys",
      "width=510px,height=663px,menubar=no,location=no,resizable=no",
    )
  }, [streamerName, scheduleId])

  return (
    <div className="utilB">
      {!isSearch ? (
        <>
          <div className="toolB">
            <button
              title="폰트 설정"
              onClick={() => {
                open("MANAGER_FONT_SETTING")
              }}
            >
              <FaCog className={styles.icon}/>
            </button>
            {showUserSearchButton && (
              <button
                title="시청자 검색"
                onClick={() => {
                  onIsSearchChange(true)
                }}
              >
                <FaSearch className={styles.icon}/>
              </button>
            )}
            <button
              title="채팅지원"
              onClick={() => {
                openHotkeyPage()
              }}
            >
              <RiChatSettingsFill
                className={classNames(styles.icon, styles.hotkeys)}
              />
            </button>
          </div>
          <h5>현재 접속자: {users.length}</h5>
        </>
      ) : (
        <>
          <input
            key="viewSearchBox"
            type="search"
            placeholder="검색할 닉네임을 입력해주세요"
            className={styles.searchBox}
            value={searchKeyword}
            onChange={(e) => onSearchKeywordChange(e.target.value)}
          />
          <button
            title="취소"
            onClick={() => {
              onIsSearchChange(false)
              onSearchKeywordChange("")
            }}
          >
            <FaTimes className={`${styles.cancel}`} />
          </button>
        </>
      )}
    </div>
  )
}

export default UtilBox
